<template>
  <section class="ds-job-list-box">
    <div class="flex all-t" @click="goDetail">
      <div class="ds-job-list-img mr10">
        <img :src="item.ShopLogoUrl || defaultImg" alt/>
      </div>
        <div class="ds-job-list-info flex-1">
        <p v-if="!item.ShopColorName">
          <span class="f14 f-b lb-vm-singline pr4">{{item.ShopName}}</span>
        </p>
        <p v-if="item.ShopColorName">
          <span class="f14 f-b lb-vm-singline">{{item.ShopUnColorName1}}</span><span class="f14 f-b lb-vm c-orange">{{item.ShopColorName}}</span><span class="f14 f-b lb-vm">{{item.ShopUnColorName2}}</span>
        </p>
        <h3 class="f11 mt10">{{item.ContractAddress}}</h3>
        <p class="f11" v-if="mapAddress">距离{{item.Distance}}</p>
      </div>
    </div>
    <div class="van-hairline--top ds-job-list-footer">
      <!-- <div class="fl f12 c-gray">
        <span class="mr5">招聘 <span class="c-000">{{item.RecruitCount}}</span>人</span>
        <span class="mr5">已报名 <span class="c-orange">{{item.PickCount}}</span>人</span>
        <span>已入职 <span class="c-orange">{{item.SuccessCount}}</span>人</span>
      </div> -->
      <div class="fr txt-r">
        <van-button
          type="primary" round size="small"
          class="btn-gradient plr24"
          @click="goDetail">
          <span class="f14">查看岗位</span>
        </van-button>
      </div>
    </div>
  </section>
</template>

<script>

  export default {
    name: 'shop-item',
    data() {
      return {
        defaultImg: require('../../assets/images/detail/pic-temp.jpg')
      };
    },
    props: {
      item: {
        type: Object,
        default: () => {
        }
      },
      mapAddress: {
        type: Object,
        default: null
      },
      searchItem: {
        type: String,
        default: ''
      }
    },
    methods: {
      goDetail() {
        const params = new URLSearchParams({
          id: this.item.ShopSysNo,
          name: this.item.ShopName || '',
          storeUrl: this.item.ShopLogoUrl || '',
          address: this.item.ContractAddress || ''
        });
        this.go(`store-detail?${params.toString()}`);
      }
    }
  };
</script>
